import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import $dvPge$react, { useRef as $dvPge$useRef, useEffect as $dvPge$useEffect } from "react";
import { Picker as $dvPge$Picker } from "emoji-mart";

function $e5534fc185f7111e$export$2e2bcd8739ae039(props) {
  const ref = (0, $dvPge$useRef)(null);
  const instance = (0, $dvPge$useRef)(null);
  if (instance.current) instance.current.update(props);
  (0, $dvPge$useEffect)(() => {
    instance.current = new (0, $dvPge$Picker)(_objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
    return () => {
      instance.current = null;
    };
  }, []);
  return /*#__PURE__*/(0, $dvPge$react).createElement("div", {
    ref: ref
  });
}

export { $e5534fc185f7111e$export$2e2bcd8739ae039 as default };